import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import {
  IComplaintFeedbackBody,
  ComplaintFeedbackForm,
} from './';
import { IState } from '../../../store';
import {
  sendFeedbackComplaint,
  statusChanger,
  EFeedbackComplaint,
} from '../../../store/complaint/feedback_complaint';

export function mapStateToProps(state: IState) {
  /* istanbul ignore next */
  const { complaintId, status } = state.complaintFeedbackFrom;
  /* istanbul ignore next */
  const { user } = state.offerData;
  /* istanbul ignore next */
  const { getUserFeedback } = state.complaint;

  /* istanbul ignore next */
  const userEmail = user && user.isAuthenticated
    ? user.email
    : undefined;

  return {
    complaintId,
    sendFormStatus: status,
    userEmail: userEmail || undefined,
    getUserFeedback,
  };
}

/* istanbul ignore next */
export function mapDispatchToProps(dispatch: Dispatch<IState>) {
  return {
    sendComplaintFeedback: (body: IComplaintFeedbackBody) => dispatch(sendFeedbackComplaint(body)),
    statusChanger: (status: EFeedbackComplaint) => dispatch(statusChanger(status)),
  };
}

export const ComplaintFeedbackFormContainer = connect(mapStateToProps, mapDispatchToProps)(ComplaintFeedbackForm);
